import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import type { RichTranslationValues } from 'next-intl';
import type { ComponentPropsWithoutRef } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

export interface LandingPageHeroDescriptionProps extends ComponentPropsWithoutRef<'p'> {
  readonly content: MessageKey;
  readonly tValues?: RichTranslationValues | undefined;
  readonly hasBackgroundImage: boolean;
}

const LandingPageHeroDescription = ({
  className,
  content,
  tValues,
  hasBackgroundImage,
}: LandingPageHeroDescriptionProps) => {
  return (
    <Typography
      className={cx(
        'relative text-center text-base md:text-body-lg lg:text-left',
        {
          'text-center lg:text-left': hasBackgroundImage,
        },
        className,
      )}
      color="inherit"
      data-cy="landing-page-hero-description"
    >
      <RichText messageKey={content} tValues={tValues} />
    </Typography>
  );
};

export default LandingPageHeroDescription;
